import UserAvailable from "@/entities/filters/UserAvailable";

const contractorsCollectionFiltersTemplate = {
  name: "",
  countries: [],
  states: [],
  cities: [],
  available: "all" as UserAvailable,
  titles: [],
  skills: [],
  projects: [],
  minRate: "",
  maxRate: "",
  managers: [],
};

export default contractorsCollectionFiltersTemplate;